/**
 * Hero туузан дээрх цас — дээрээс аажим унах цэгүүд (dark glass, 2026-10-05).
 *
 * Зөвхөн ЧИМЭГЛЭЛ: `aria-hidden`, `pointer-events-none`. Ямар ч
 * мэдээлэл дамжуулахгүй тул дэлгэц уншигчид огт хүрэхгүй.
 *
 * ⚠️ САНАМСАРГҮЙ ТОО ХЭРЭГЛЭХГҮЙ. `Math.random()` дуудвал дахин
 *    рендер бүрт цэгүүд байрандаа үсэрч, анимаци эхнээсээ эхэлнэ
 *    (мэндчилгээ 5 секунд тутам солигддог тул энэ мэдэгдэхүйц).
 *    Оронд нь алтан харьцааны үлдэгдлээр индексээс ТОГТМОЛ,
 *    жигд тархсан утга гаргана.
 *
 * ⚠️ Хөдөлгөөн нь `transform` + `opacity` дээр л явна — layout ба
 *    paint дахин тооцоологдохгүй, compositor дээр гүйнэ. Дүрслэл нь
 *    `.hero-stream` дотор (`index.css`), `prefers-reduced-motion`
 *    үед бүхэлдээ унтарна.
 */

import type { CSSProperties } from 'react';

/**
 * Цэгийн тоо.
 *
 * ⚠️ 18 цэг ХЭТ ЦӨӨН байсан — 1500px өргөн туузан дээр нэг цэг
 *    ~16,000px² тутамд ногдож, урсгал биш санамсаргүй тоос шиг
 *    харагдана. Багасгах бол 30-аас доош бүү оруул.
 */
const COUNT = 70;

/** Индексээс жигд тархсан 0..1 тоо (алтан харьцааны үлдэгдэл). */
const spread = (i: number, seed: number) => (i * 0.618033988749895 + seed) % 1;

const DOTS = Array.from({ length: COUNT }, (_, i) => {
  // Гурван тэнхлэг: байрлал · ГҮН · фаз. Гүн нь дөрвөн шинжийг
  // ЗЭРЭГ удирдана — ойрхон цэг том, тод, хурдан, илүү найгана.
  // Дөрвийг тус тусад нь санамсаргүй тарааж болох ч тэгвэл жижиг
  // бүдэг цэг хурдан гүйж, гүний мэдрэмж алдагдана.
  const x = spread(i, 0.11);
  const depth = spread(i * 3, 0.47); // 0 = хол, 1 = ойр
  const phase = spread(i * 7, 0.73);

  const dur = 16 - depth * 10; // хол нь удаан (16s) · ойр нь хурдан (6s)

  return {
    '--x': `${(1 + x * 98).toFixed(1)}%`,
    '--size': `${(2.2 + depth * 4.4).toFixed(1)}px`,
    '--dur': `${dur.toFixed(1)}s`,
    // Сөрөг саатал — эхний хүрээнд цэгүүд аль хэдийн урсаж явна.
    // Эерэг байвал тууз эхний секундүүдэд хоосон харагдана.
    '--delay': `${(-phase * dur).toFixed(1)}s`,
    '--o': (0.2 + depth * 0.42).toFixed(2),
    '--bob': `${(4 + depth * 10).toFixed(1)}px`, // хэвтээ найгалт
  } as CSSProperties;
});

export function HeroStream() {
  return (
    <div aria-hidden className="hero-stream pointer-events-none absolute inset-0">
      {DOTS.map((style, i) => (
        <span key={i} style={style} />
      ))}
    </div>
  );
}
